import { render, staticRenderFns } from "./TvShop.vue?vue&type=template&id=a46cd424&"
import script from "./TvShop.vue?vue&type=script&lang=js&"
export * from "./TvShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports